// Subtle scroll-reveal used throughout the storefront for an editorial,
// unhurried feel. No-ops gracefully if the browser lacks IntersectionObserver,
// and CSS handles the prefers-reduced-motion opt-out on its own.
//
// Two sources of targets:
// 1. A fixed list of built-in section selectors below.
// 2. Any element carrying `data-animate` (e.g. a Group theme block with its
//    "Animation" setting enabled) — merchant-controlled, not hardcoded here.
document.addEventListener('DOMContentLoaded', () => {
  if (!('IntersectionObserver' in window)) return;

  const revealSelectors = [
    '.rich-text__content > *',
    '.image-with-text__content > *',
    '.promo-banner__content > *',
    '.newsletter-section__content > *',
    '.product-grid__item',
    '.trust-row__item',
    '.shop-by-grid__item',
    '.shop-by-color__item',
    '.testimonials__item',
    '.how-it-works__step',
    '.hair-guide__item',
    '.ugc-gallery__item',
    '.before-after__item',
    '.featured-blog__item',
    '[data-animate]',
  ].join(', ');

  const targets = document.querySelectorAll(revealSelectors);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const customDelay = el.dataset.animateDelay;
        if (customDelay) {
          el.style.transitionDelay = `${customDelay}ms`;
        } else {
          const siblingIndex = Array.from(el.parentElement?.children || []).indexOf(el);
          el.style.transitionDelay = `${Math.min(siblingIndex, 6) * 60}ms`;
        }
        el.classList.add('is-visible');
        observer.unobserve(el);
      });
    },
    { threshold: 0, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach((el) => {
    el.classList.add('reveal');
    if (el.dataset.animate) el.classList.add(`reveal--${el.dataset.animate}`);
    observer.observe(el);
  });
});
